// "Bugün kimi aramalıyım?" — bekleyen oda tekliflerinin takip durumu (saf fonksiyonlar, veritabanı değişikliği yok).
//
// Yalnızca 'Onay Bekliyor' teklifler. Bekleme süresi teklifin kayıt gününden (createdAt) sayılır.
//   3+ gün → 'warn' (sarı), 7+ gün → 'late' (kırmızı); girişine 14 gün ya da daha az kalan bekleyen → checkInSoon.
// Giriş günü geçmiş bekleyen teklif takip listesine girmez (stale: "Onaylanmadı" yapılması gerekir).
import { dateKey, todayKey, daysBetween } from './offerShare';

export const FOLLOW_UP = { warnDays: 3, lateDays: 7, checkInSoonDays: 14 };
export const PENDING_STATUS = 'Onay Bekliyor';

// → null (bekleyen değil) ya da { days, level, daysToCheckIn, checkInSoon, stale, needsAction }
export const offerFollowUp = (offer, now = new Date()) => {
  if (!offer || offer.status !== PENDING_STATUS) return null;
  const today = todayKey(now);
  const created = dateKey(offer.createdAt);
  const days = created ? Math.max(0, daysBetween(created, today)) : null;
  const checkIn = dateKey(offer.checkIn);
  const daysToCheckIn = checkIn ? daysBetween(today, checkIn) : null;
  const level = days === null ? 'fresh' : days >= FOLLOW_UP.lateDays ? 'late' : days >= FOLLOW_UP.warnDays ? 'warn' : 'fresh';
  const stale = daysToCheckIn !== null && daysToCheckIn < 0;
  const checkInSoon = !stale && daysToCheckIn !== null && daysToCheckIn <= FOLLOW_UP.checkInSoonDays;
  return { days, level, daysToCheckIn, checkInSoon, stale, needsAction: !stale && (level !== 'fresh' || checkInSoon) };
};

// "Bugün verildi" · "1 gündür bekliyor" · "12 gündür bekliyor"
export const followUpAgeText = (f) => {
  if (!f || f.days === null) return '';
  return f.days === 0 ? 'Bugün verildi' : `${f.days} gündür bekliyor`;
};

// "Girişe 5 gün" · "Giriş yarın" · "Giriş bugün"
export const checkInSoonText = (f) => {
  if (!f || !f.checkInSoon) return '';
  if (f.daysToCheckIn === 0) return 'Giriş bugün';
  if (f.daysToCheckIn === 1) return 'Giriş yarın';
  return `Girişe ${f.daysToCheckIn} gün`;
};

// Takip edilecekler: girişi yaklaşanlar önce (en yakın giriş), sonra en uzun bekleyenler
export const followUpList = (offers, now = new Date()) => (offers || [])
  .map((offer) => ({ offer, f: offerFollowUp(offer, now) }))
  .filter((x) => x.f && x.f.needsAction)
  .sort((a, b) => {
    if (a.f.checkInSoon !== b.f.checkInSoon) return a.f.checkInSoon ? -1 : 1;
    if (a.f.checkInSoon && a.f.daysToCheckIn !== b.f.daysToCheckIn) return a.f.daysToCheckIn - b.f.daysToCheckIn;
    return (b.f.days || 0) - (a.f.days || 0);
  });

// Giriş günü geçtiği hâlde hâlâ 'Onay Bekliyor' olanlar (temizlik için)
export const staleOffers = (offers, now = new Date()) => (offers || []).filter((o) => offerFollowUp(o, now)?.stale);
